<template>
  <v-container>
    <div class="d-flex justify-center">
      <v-card
        width="100%"
        max-width="320"
        tile
      >
        <v-card-title>
          Dummy Auth View
        </v-card-title>
        <v-card-text>
          This is just a dummy view used to demonstrate the authGuard
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
export default {

}
</script>
